import styled from 'styled-components'
import theme from 'theme_'

export const ProgressCircleContainer = styled.div<{ size: number }>`
  height: ${({ size }) => size * 16}px;
  width: ${({ size }) => size * 16}px;
  @media ${theme.devices.tablet} {
    height: ${({ size }) => size * 12}px;
    width: ${({ size }) => size * 12}px;
  }
`
